import { useReducer } from 'react';
import { type } from './medicamentosTramitesActions';
import { medicamentosTramitesReducer } from './medicamentosTramitesReducer';
import { MedicamentosTramitesContext } from './MedicamentosTramitesContext';

const init = () => {
  return {
    anualList: [],
    mensualDate: null,
    mensualList: [],
    anualDate: null,
  };
};

export const MedicamentosTramitesProvider = ({ children }) => {
  const [medicamentosTramitesState, dispatch] = useReducer(medicamentosTramitesReducer, {}, init);

  const setMedicamentosTramitesAnualList = (payload) => {
    dispatch({
      type: type.anualList,
      payload: payload.data,
      date: payload.date,
    });
  };

  const setMedicamentosTramitesMensualList = (payload) => {
    dispatch({
      type: type.mensualList,
      payload: payload.data,
      date: payload.date,
    });
  };

  return (
    <MedicamentosTramitesContext.Provider
      value={{
        ...medicamentosTramitesState,
        setMedicamentosTramitesAnualList,
        setMedicamentosTramitesMensualList,
      }}
    >
      {children}
    </MedicamentosTramitesContext.Provider>
  );
};
